import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import URL_MAPPING from "../../routes/constants";



import EmpList from '../../assets/icons/emp-list.svg';
import ManageAddr from '../../assets/icons/ManageAddr.svg';
import ManageAddrDark from '../../assets/icons/ManageAddrDark.svg';
import MapView from "../../assets/icons/map-view.svg";
import Notification from "../../assets/notification.svg";
import Inventory from "../../assets/icons/map-view.svg";


import Home from "../../assets/icons/home-icon.svg";
import Dashboard from "../../assets/icons/dashboard.svg";

import VisitReport from "../../assets/icons/visit-report.svg";

import { useTranslation } from "react-i18next";
import DownArrow from "../../assets/down-arrow.svg";
import UpArrow from "../../assets/up-arrow.svg";
import Reports from "../../assets/icons/reports.png"

import KAKRSurveydark from "../../assets/icons/kakrdark.png"


interface NavbarProps {
  open: boolean;
  setOpen: any;
}
const Navbar: React.FC<NavbarProps> = ({ open, setOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [navItems, setNavItems] = useState<any>([]);
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const navRef = useRef<HTMLDivElement>(null);
  const isActive = (route: string) => location.pathname.startsWith(route);

  const [isRTL, setIsRTL] = useState(false);
  const [isReportsOpen, setIsReportsOpen] = useState(false);
  const handleSubMenuClick = (route: string) => {
    navigate(route);
    setIsReportsOpen(false);
    setOpen(false);
  };
  const handleSection = async (section: any) => {
    const accessibleReportNames = ['AUTH','ROLEPERMISSION','ROLE_EMPLOYEE','VISIT_REPORT', 'ACTIVITY_REPORT']
    switch (section) {
      case "admin_panel":
        setNavItems([
          {
            route: URL_MAPPING.LANDING,
            label: t("Nav.home"),
            icon: Home,
            iconDark: Home, // Assuming Home doesn't have a dark version
          },
          {
            route: URL_MAPPING.ADMINPANEL,
            label: "Employee",
            icon: Reports,
            iconDark: Reports,
          },
          
          {
            route: URL_MAPPING.CUSTOMERS,
            label: "Customers",
            icon: Inventory,
            iconDark: Inventory,
          },
          {
            route: URL_MAPPING.AUTH,
            label: "Auth",
            icon: Dashboard,
            iconDark: Dashboard,
            isCollapsible: true,
            subItems: [
              ...(accessibleReportNames.includes("AUTH") ? [
                {
                  route: URL_MAPPING.AUTH,
                  label: "Auth",
                  icon: Dashboard,
                  iconDark: Dashboard,
                }] : []),
              ...(accessibleReportNames.includes("ROLE_EMPLOYEE") ? [
                {
                  route: URL_MAPPING.ROLE_EMPLOYEE,
                  label: "ROLE EMPLOYEE",
                  icon: Dashboard,
                  iconDark: Dashboard,
                }] : []),
                ...(accessibleReportNames.includes("ROLEPERMISSION") ? [
                  {
                    route: URL_MAPPING.ROLEPERMISSION,
                    label: "ROLE PERMISSION",
                    icon: MapView,
                    iconDark: MapView,
                  }] : []),


              ]
          },
          {
            route: URL_MAPPING.OFFERS,
            label: "Offers",
            icon: Dashboard,
            iconDark: Dashboard,
          },
          {
            route: URL_MAPPING.STORAGEMAPPING,
            label: "Storage Mapping",
            icon: MapView,
            iconDark: Dashboard,
          },
          {
            route: URL_MAPPING.MEDIA,
            label: "Media",
            icon: Dashboard,
            iconDark: Dashboard,
          },
          {
            route: URL_MAPPING.TRAININGVIDEOS,
            label: "Training Videos",
            icon: Dashboard,
            iconDark: Dashboard,
          },
          {
            route: URL_MAPPING.TERRITORY,
            label: "Territory",
            icon: Reports,
            iconDark: Dashboard,
          },
          {
            route: URL_MAPPING.EMPLOYEEMONTHLY,
            label: "Monthly Target",
            icon: KAKRSurveydark,
            iconDark: Dashboard,
          },
          {
            route: URL_MAPPING.CONFIG,
            label: "Config",
            icon: Dashboard,
            iconDark: Dashboard,
          },
          {
            route: URL_MAPPING.ACTIVATION,
            label: "Activation",
            icon: VisitReport,
            iconDark: Dashboard,
          },
          // {
          //   route: URL_MAPPING.REPORT,
          //   label: "Report",
          //   icon: Dashboard,
          //   iconDark: Dashboard,
          // },
          // {
          //   route: URL_MAPPING.NOTIF,
          //   label: "Notification",
          //   icon: Notification,
          //   iconDark: Notification,
          // },
          {
            route: URL_MAPPING.MASTERSYNC,
            label: "Master Data Sync",
            icon: Dashboard,
            iconDark: Dashboard,
          },
       
      
          
          {
            route: URL_MAPPING.ROADNET,
            label: "Roadnet Sync",
            icon: MapView,
            iconDark: MapView,
          },
          // {
          //   route: URL_MAPPING.ROUTE_PLANNING_GENERATE,
          //   label: "Route planning generate",
          //   icon: MapView,
          //   iconDark: MapView,
          // },
          {
            route: URL_MAPPING.SALES,
            label: "Sales Rule",
            icon: Dashboard,
            iconDark: Dashboard,
          },
        

        ]);
        break;
      case "Territory":
        setNavItems([
          {
            route: URL_MAPPING.LANDING,
            label: t("Nav.home"),
            icon: Home,
            iconDark: Home,
          },
          {
            route: URL_MAPPING.LMDTERRITORY,
            label: "LMD Territory",
            icon: MapView,
            iconDark: MapView,
          },
          {
            route: URL_MAPPING.TERRITORYMAPVIEW,
            label: "Territory Map View",
            icon: MapView,
            iconDark: MapView,
          },
        ]);
        break;
      default:
        setNavItems([
          {
            route: URL_MAPPING.LANDING,
            label: t("Nav.home"),
            icon: Home,
            iconDark: Home,
          },
        ]);
        break;
    }
  };

  const dir = document.documentElement.getAttribute("dir");
  useEffect(() => {
    const section = localStorage.getItem("section");
    if (!section) {
      navigate(URL_MAPPING.LANDING);
    }
    handleSection(section);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dir]);

  // Update navbar when location changes
  useEffect(() => {
    // If on a territory route, ensure section is set
    if (location.pathname === URL_MAPPING.LMDTERRITORY || location.pathname === URL_MAPPING.TERRITORYMAPVIEW) {
      const currentSection = localStorage.getItem("section");
      if (currentSection !== "Territory") {
        localStorage.setItem("section", "Territory");
        handleSection("Territory");
        return;
      }
    }
    
    const section = localStorage.getItem("section");
    if (section) {
      handleSection(section);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  useEffect(() => {
    let isRtl = false;
    isRtl = dir === "rtl";
    setIsRTL(isRtl);
  }, [dir]);
  const handleClickOutside = (event: MouseEvent) => {
    if (navRef.current && !navRef.current.contains(event.target as Node)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      ref={navRef}
      className={`md:flex h-screen md:h-[calc(100%-51px)] border-2 bg-[#FFFFFF] flex flex-col justify-start items-center absolute ${
        isRTL ? "right-0" : "left-0"
      } gap-0 z-30 top-0 md:top-[48px] 
  ${
    open ? "w-[251px] md:w-[220px]" : "hidden w-[56px] delay-150"
  } transition-all duration-300`}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => {
        setOpen(false);
        setIsReportsOpen(false);
      }}
    >
      <ul
        className={`flex flex-col items-stretch justify-start gap-1 mt-3 w-full
          ${open ? 'overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100 pr-1' : 'overflow-hidden'}
          max-h-[calc(100vh-100px)] overflow-x-hidden`}
      >
{navItems.map((item: any, index: number) => {
  const isActiveSubMenu =
    item.label === t("Auth") && isReportsOpen;
  const isAnySubMenuActive =
    item.label === t("Auth") &&
    navItems
      .find((navItem: any) => navItem.label === t("Auth"))
      ?.subItems.some((subItem: any) => isActive(subItem.route));

  const isAuthItem = item.label === t("Auth");

  return (
    <li
      key={index}
              className={`w-full relative items-center flex flex-col ${
        isActive(item.route) || isActiveSubMenu || isAnySubMenuActive
          ? "bg-[#B0F7F5]"
          : ""
      }`}
    >
      <button
        className="h-12 px-3 flex gap-3 cursor-pointer items-center w-full justify-between"
        onClick={() => {
          if (item.isCollapsible) {
            setIsReportsOpen((prev) => !prev);
          } else {
            navigate(item.route);
          }
        }}
      >
        <div className="flex gap-3 items-center min-w-0">
          <img
            src={
              isActive(item.route) ||
              hoveredIndex === index ||
              isAnySubMenuActive
                ? item.iconDark
                : item.icon
            }
            alt={item.label}
            className="w-5 h-5"
          />
          <p
            className={`transition-opacity duration-200 delay-150 ${
              open ? "opacity-100" : "opacity-0"
            } group-hover:opacity-100 group-hover:text-black truncate ${
              isActive(item.route) || isAnySubMenuActive
                ? "text-black"
                : "text-grey"
            }`}
          >
            {item.label}
          </p>
        </div>
        {item.isCollapsible && (
          <span>
            <img src={isReportsOpen ? UpArrow : DownArrow} alt="" />
          </span>
        )}
      </button>

      {/* ✅ Submenu rendered inside "Auth" item */}
      {isReportsOpen && isAuthItem && (
        <ul
          className={`absolute top-full left-0 bg-white border mt-1 shadow-md rounded-md z-50 min-w-[216px] ${
            isRTL ? "right-0 left-auto" : ""
          }`}
        >
          {item.subItems?.map((subItem: any, subIndex: number) => (
            <li
              key={subIndex}
              onClick={() => handleSubMenuClick(subItem.route)}
              className={`w-full items-center h-10 px-3 flex group cursor-pointer ${
                isActive(subItem.route)
                  ? "bg-[#B0F7F9]"
                  : "group-hover:text-black"
              }`}
            >
              <button className="flex gap-3 items-center w-full">
                <img
                  src={
                    isActive(subItem.route)
                      ? subItem.iconDark
                      : subItem.icon
                  }
                  alt={subItem.label}
                  className="w-4 h-4"
                />
                <p
                  className={`transition-opacity duration-200 delay-150 ${
                    open ? "opacity-100" : "opacity-0"
                  } group-hover:opacity-100 group-hover:text-black truncate ${
                    isActive(subItem.route) ? "text-black" : "text-grey"
                  }`}
                >
                  {subItem.label}
                </p>
              </button>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
})}

      </ul>

      {/* Submenu */}
    
    </div>
  );
};

export default Navbar;
